import ChatInterfaceBase from './base'
import PmInterface from './pm'

import {
    VIEW_STOP_REASON_LIMIT_REACHED
} from '../../constants/streaming';

import hitagi from 'hitagi-js';

import {
    PM_ACCESS_ALLOW,
    PM_ACCESS_DENY,
    PM_ACCESS_UNDEFINED,
    PM_ACCESS_RESET_REASON_REQUEST_CANCEL
} from '../../constants/pm';

import {
    ROOM_REFRESH_INTERVAL
} from '../../constants/rooms';

import {
    TOO_MANY_USERS_REASON,
    ANONYMOUS_NICK_ALREADY_EXISTS,
    BLACKLISTED_REASON,
    BLOCKED_REASON,
    EXCLUDED_REASON,
    NONEXISTENT_ROOM_REASON,
    ROOM_INACTIVE_REASON,
    PAYMENT_REQUIRED,
    INSUFFICIENT_FUNDS
} from "../../constants/chatInterface";

const BASE_LIB_LOADING_INTERVAL = 30000;
const BASE_LIB_LOADING_ATTEMPTS = 5;

export default class ChatInterfaceHitagi extends ChatInterfaceBase {
    constructor(loginData, constraints, debug) {
        super(loginData, constraints);

        this._loggedInUser = {};
        this._getRoomListInterval = 0;
        this._debug = debug;
        this.baseLibBound = false;

        this.hitagi = new hitagi();

        this.pm = new PmInterface(loginData, constraints);
        this.pm.getLoggedInUser = this.getLoggedInUser.bind(this)

        //if (this.loadBaseLib()) {
            this.bindBaseLib();
        //} else {
        //    console.log('Base lib initial load error');
        //}
    }

    loadBaseLib() {
        if (window.Hitagi) return true;

        var hitagiScript = document.querySelector('script[data-hitagi-js]');

        if (hitagiScript) {
            var newHitagiScript = document.createElement('script');

            newHitagiScript.type = hitagiScript.type;
            newHitagiScript.src = hitagiScript.src;
            newHitagiScript.async = false;
            newHitagiScript.setAttribute('data-hitagi-js', '');

            hitagiScript.parentNode.replaceChild(newHitagiScript, hitagiScript);
            if (window.Hitagi) return true;
        }

        return false;
    }

    keepLoadingBaseLib(Success, Fail) {
        var that = this;

        var attemptCount = 0;

        var intervalId = setInterval(function () {
            if (that.loadBaseLib()) {
                clearInterval(intervalId);
                Success();
            } else if (++attemptCount >= BASE_LIB_LOADING_ATTEMPTS) {
                // clearInterval(intervalId);
                Fail();
            }
        }, BASE_LIB_LOADING_INTERVAL);
    }

    _getLoginConfig() {
        if (this.isAnonymous()) {
            return {
                Nick: this.getGuestNick(),
                ServerUri: this._loginData.server_uri,
                RoomId: this._loginData.roomid,
                AdditionalInfo: this._loginData.connection_id + "_" + window.fingerprint,
                SnapshotIntervalSec: 180,
                PaymentAllowed: this._loginData.payment_allowed,
                "__debug__" : this._debug === "1",
            }
        }

        return {
            Uid: this.getUid(),
            Token: this.getToken(),
            ServerUri: this._loginData.server_uri,
            RoomId: this._loginData.roomid,
            AdditionalInfo: this._loginData.connection_id + "_" + window.fingerprint,
            SnapshotIntervalSec: 180,
            PaymentAllowed: this._loginData.payment_allowed,
            "__debug__" : this._debug === "1"
        }
    }

    bindBaseLib() {
        var that = this;

        this.hitagi.on('rooms_list', function(List) { that.trigger('room_list', List) });
        this.hitagi.chat.on_list(function(List) { that.trigger('room_client_list', List) });
        this.hitagi.on('room:client_login', function(User) {
            if(that._debug === "ws") console.log("client_login", User.nick);
            that.trigger('room_client_login', User);
        });
        this.hitagi.on('room:client_logout', function(User) {
            if(that._debug === "ws") console.log("client_logout", User.nick);
            that.trigger('room_client_logout', User);
        });
        this.hitagi.on('room:client_update', function(User) {
            if(that._debug === "ws") console.log("client_update", User.nick);
            that.trigger('room_client_update', User);
        });

        this.hitagi.on("room_destroyed", function(Args) {
            that._disconnectedByServer = true;
            that.trigger("room_destroyed", Args.roomid);
        });

        this.hitagi.on("room:room_updated", function(Args) {
            that.trigger("room_updated", Args.room);
        })

        this.hitagi.on("room:subscription_payment_failed", function(Args) {
            that.trigger("room_subscription_payment_failed", Args);
            that._disconnectedByServer = true;
        });

        this.hitagi.on('status:motd', function (Data) { that.trigger('status_motd', Data) });
        this.hitagi.chat.on_message(function (Message) {
            if(that._debug === "ws") console.log("room_message", Message);
            that.trigger('room_message', Message);
        });

        this.hitagi.on('service_message', function(ServiceMessage) { that.trigger('service_message', ServiceMessage) });

        this.on('login_success', this._loginSuccess.bind(this));
        this.on('login_error', this._loginError.bind(this));

        this.hitagi.on('close', function() { that.trigger('close') });
        this.hitagi.on('error', function() { that.trigger('error') });

        this.on(['close', 'error'], this._disconnect.bind(this));
        this._roomListRefresh = this._roomListRefresh.bind(this);
        this._getRoomListSuccess = this._getRoomListSuccess.bind(this);
        this._getRoomListError = this._getRoomListError.bind(this);

        this.handleEnumerateDevices = this.handleEnumerateDevices.bind(this);
        this.handleGetSources = this.handleGetSources.bind(this);
        this.hitagi.on('stream:watching_me', function(Args) { that.trigger('stream_watching_me', Args) });
        this.hitagi.on('stream:watcher_count', function(Args) { that.trigger('stream_watcher_count', Args) });
        this.hitagi.on('stream:stream_update', function(Args) { that.trigger('stream_stream_update', Args) });
        this.hitagi.on('stream:limit_reached', function() { that.trigger('stream_limit_reached') });

        // connection state handling code begin
        this.on('close', this._onClose.bind(this));

        this.reconnect = this.reconnect.bind(this);
        this.updateReconnectionHandle = this.updateReconnectionHandle.bind(this);
        this.stopReconnection = this.stopReconnection.bind(this);

        this._disconnectedByServer = false;
        this._loggedOut = false;

        this._reconnectionHandle = null;
        this._reconnectionInterval = 0; // 0 seconds - initial value
        this._reconnectionIncrement = 5;
        this._reconnectionIntervalMax = 60;

        this.hitagi.on("disconnect", function() {
            that._disconnectedByServer = true;
            that.trigger("disconnect");
        });
        // connection state handling code end

      //  this.pm.bindBaseLib();

        this.baseLibBound = true;
    }

    finishConnection() {
        this.getUserMediaVideoSources();       

        this.startStreaming(this._constraints);
    }

    _loginSuccess(User) {
        this._loggedInUser = User;
        this._disconnectedByServer = false;
        this.getRoomList(this._getRoomListSuccess, this._getRoomListError);
        this._getRoomListInterval = setInterval(this._roomListRefresh, ROOM_REFRESH_INTERVAL);

        if (!User.other_connections) {
            this.finishConnection()
        }
    }

    _loginError(Code, Reason, Data) {
        // todo: check if setting _disconnectedByServer is really needed here
        if (
            Reason === TOO_MANY_USERS_REASON ||
            Reason === ROOM_INACTIVE_REASON ||
            Reason === BLOCKED_REASON ||
            Reason === EXCLUDED_REASON ||
            Reason === BLACKLISTED_REASON ||
            Reason === NONEXISTENT_ROOM_REASON ||
            Reason === ANONYMOUS_NICK_ALREADY_EXISTS ||
            Reason === PAYMENT_REQUIRED ||
            Reason === INSUFFICIENT_FUNDS
        ) {
            this._disconnectedByServer = true;
        }

        // todo: handle exceptions better according to errorObj
        // startReconnection();
    }

    _onClose() {
        if (!this._disconnectedByServer && !this._loggedOut && !this.isAnonymous()) {
            this.startReconnection();
        }
    }

    _disconnect() {
        if (this._getRoomListInterval) clearInterval(this._getRoomListInterval);
    }

    getRoomList(Success, Error) {
        return this.hitagi.status.rooms_list(Success, Error);
    }

    _roomListRefresh() {
        this.getRoomList(this._getRoomListSuccess, this._getRoomListError);
    }

    _getRoomListSuccess(List) {
        this.trigger('room_list', List.rooms);
    }

    _getRoomListError() {

    }

    getLoggedInUser() {
        return this._loggedInUser;
    }

    isLoggedIn() {
        return typeof this._loggedInUser.uid !== 'undefined';
    }

    isGenderValid(gender) {
        let valid_genders = this.getValidGenders();
        return valid_genders && valid_genders.length > 0 ? valid_genders.includes(gender) : true;
    }

    login(Success, Error) {
        this.trigger('prelogin');
       // this.pm.login(this._loginData);
        var that = this;

        if (!this.baseLibBound) {
            var args = arguments;

            this.keepLoadingBaseLib(function() {
                that.bindBaseLib();
                that.login.call(that, args);
            }, function() {
                that.trigger('base_lib_not_loaded');
            });

            return;
        }

        this.hitagi.login(
            this._getLoginConfig(),
            function(User) {
                if (typeof Success == "function") Success(User);
                that.trigger('login_success', User)
            },
            function(Code, Reason, Data) {
                if (typeof Error == "function") Error(Code, Reason, Data);
                that.trigger('login_error', Code, Reason, Data)
            }
        );

        
    }

    startReconnection() {
        // reconnection already started
        if (this._reconnectionHandle) return false;

        this.updateReconnectionHandle();
    }

    forceReconnection() {
        this._disconnectedByServer = false;
        this.startReconnection();
    }

    stopReconnection() {
        clearTimeout(this._reconnectionHandle);
        this._reconnectionHandle = 0;
        this._reconnectionInterval = 0;
    }

    updateReconnectionHandle() {
        if (this._reconnectionInterval < this._reconnectionIntervalMax) this._reconnectionInterval += this._reconnectionIncrement;
        this._reconnectionHandle = setTimeout(this.reconnect, this._reconnectionInterval * 1000);
    }

    reconnect() {
        var that = this;
        this.trigger('prereconnect');

        this.hitagi.login(
            this._getLoginConfig(),
            function(User) {
                that.stopReconnection();
                that.trigger('reconnection_success');
                that.trigger('login_success', User)

            },
            function() {
                console.log("chatInerface reconnect() error", arguments);
                that.trigger('reconnection_error');
                that.updateReconnectionHandle();
            }
        );
    }

    disconnectOther() {
        var that = this;

        this.hitagi.disconnect_other();
    }

    logout() {
        this._loggedOut = true;
        this._loggedInUser = {};
        try {
            this.hitagi.logout();
        } catch (e) {
            console.log(e);
        }
    }

    getUserMediaVideoSources() {
        if (navigator.mediaDevices !== undefined && typeof navigator.mediaDevices.enumerateDevices == 'function') {
            navigator.mediaDevices.enumerateDevices().then(this.handleEnumerateDevices);
            return true;
        } else if (window.MediaStreamTrack && MediaStreamTrack !== undefined && typeof MediaStreamTrack.getSources == 'function') {
            MediaStreamTrack.getSources(this.handleGetSources);
            return true;
        }

        return false;
    }

    handleGetSources(SourceInfos) {
        this._videoInputDevices = [];
        /** @type {SourceInfo[]} SourceInfos **/
        for (var index in SourceInfos) {
            if (SourceInfos[index].kind !== "video") continue;
            this._videoInputDevices.push(SourceInfos[index].id);
        }

        this.onVideoInputDevicesDetected();
    }

    handleEnumerateDevices(list) {
        this._videoInputDevices = [];
        for (var index in list) {
            if (list[index].kind !== "videoinput") continue;
            this._videoInputDevices.push(list[index].deviceId);
        }

        this.onVideoInputDevicesDetected();
    }

    onVideoInputDevicesDetected() {
        if (this._videoInputDevices.length > 0) {
            // constraints.video.optional = [];
            // constraints.video.optional.push({sourceId: _videoInputDevices[0]});
        }

        if ((this._videoInputDevices.length > 0)) {
            this.trigger('video_source_found');
            if (this._videoInputDevices.length > 1) this.trigger('video_sources_multiple');
        } else {
            this.trigger('video_sources_not_found');
        }
    }

    // todo: maybe Promises instead of 'streaming_start_success'/'streaming_start_error' event triggering

    startStreaming(constraints) {
        if (!constraints) {
            constraints = this._constraints;
        }
        var that = this;
        this.hitagi.media.on_local_stream_success = function(LocalMediaStream) {
            // $(LocalMediaStream).on("active inactive addtrack removetrack ended overconstrained devicechange", function(event) { console.log("MediaStream."+event.type); console.table([this]); });
            var MediaStreamTracks = LocalMediaStream.getTracks();
            MediaStreamTracks.map(function (MediaStreamTrack) {
                // $(MediaStreamTrack).on("inactive active addtrack removetrack ended mute unmute overconstrained devicechange", function(event) { console.log("MediaStreamTrack."+event.type); console.table([this]); });

                if (MediaStreamTrack.kind == 'video') {
                    MediaStreamTrack.onended = function () {
                        that.hitagi.log('Media streaming STOPPED.');

                        that.hitagi.stream.stop();
                        that.trigger('startStreaming_media_streaming_stopped');
                        that.trigger('streaming_start_error');
                    };
                }
            });

            that.trigger('streaming_start_success', LocalMediaStream);
            that.hitagi.stream.start(LocalMediaStream);
            that.trigger('startStreaming_media_captured');
        }
        this.hitagi.media.get_user_media(constraints)
            .then( (LocalMediaStream) => {
                
            })
            .catch( (Event) => {
                that.trigger('streaming_start_error', Event.code, Event.reason);

                that.hitagi.log('Media WAS NOT captured. ' + Event.reason);
                that.trigger('startStreaming_media_not_captured');
            });

        return false;
    }

    // todo: move actual VIEW_USER_REQUEST action dispatching (made by stream_view action handler) outside of ChatInterface, see also: UserContextMenu.view()
    viewUser(StreamId, sendRequest = true) {
        this.trigger('stream_view', StreamId);
        if (sendRequest) this.sendViewRequest(StreamId);
    }

    sendViewRequest(StreamId, Ufrag) {
        let that = this;

        this.hitagi.stream.view(
            StreamId,
            function(RemoteStream) { that.trigger('stream_view_success', StreamId, Ufrag, RemoteStream); },
            function(Reason) {
                let ViewStopReason = Reason;
                if (that.hitagi.stream.LIMIT_REACHED && Reason === that.hitagi.stream.LIMIT_REACHED) ViewStopReason = VIEW_STOP_REASON_LIMIT_REACHED;
                
                that.trigger('stream_view_stop', StreamId, ViewStopReason)
            },
            function(RemoteStream) { that.trigger('stream_view_reconnect', StreamId, Ufrag, RemoteStream) }
        )
    }

    viewUserLeaveStream(StreamId) {
        this.trigger('stream_leave', StreamId);
        try {
            this.hitagi.stream.leave(StreamId);
        } catch(e) {}

    }

    talk() {
        this.hitagi.media.talk();
    }

    mute() {
        this.hitagi.media.mute();
    }

    mediaPause() {
        this.hitagi.media.pause();
    }

    mediaPlay() {
        this.hitagi.media.play();
    }

    mediaScreenshot(video) {
        return this.hitagi.media.screenshot(video);
    }

    streamScreenshot(imageData) {
        this.hitagi.stream.screenshot(imageData);
    }

    streamTakeShot(image, onSuccess, onError) {
        return this.hitagi.stream.take_shot(image, onSuccess, onError);
    }

    streamRecordStart(onStart, onStop, onError) {
        this.hitagi.stream.record_start(onStart, onStop, onError);
    }

    streamRecordStop() {
        this.hitagi.stream.record_stop();
    }

    fetchPmHistory(user) {
        return this.pm.fetchPmHistory(user);
    }

    markPmRead(recipient) {
        return this.pm.markPmRead(recipient);
    }

    // todo: move actual PM_SESSION_START action dispatching outside of ChatInterface, see also: UserContextMenu.pm()
    initiatePmSession(user, sendRequest = true) {
        return this.pm.initiatePmSession(user, sendRequest);
    }

    sendPmRequest(user) {
        return this.pm.sendPmRequest(user);
    }

    cancelPmRequest(ufrag) {
        return this.pm.cancelPmRequest(ufrag);
    }

    sendRoomMessage(message, success, error) {
        this.hitagi.chat.post_message(message, success, error)
    };

    sendPmMessage(message, to, success, error) {
        return this.pm.sendPmMessage(message, to, success, error);
    };

    sendPmTypingNotify(ufrag) {
        return this.pm.sendPmTypingNotify(ufrag);
    }

    deleteHistory(ufrag) {
        return this.pm.deleteHistory(ufrag);
    }


    allowPmAccess(ufrag) {
        return this.pm.allowPmAccess(ufrag);
    }

    denyPmAccess(ufrag) {
        return this.pm.denyPmAccess(ufrag);
    }

    resetPmAccess(user) {
        return this.pm.resetPmAccess(user);
    }

    loginVirtualRoom(Name, Password, Success, Error) {
        var that = this;

        var customSuccess = function() {
            that.trigger('room_switched', Name);
            // todo: revise somehow in the future
            that._roomListRefresh();
            Success();
        };

        this.hitagi.room.switch_room(Name, Password, customSuccess, Error);
    }

    joinRoom(Name, Password, Success, Error) {
        var that = this;

        var customSuccess = function() {
            that.trigger('room_joined', Name);
            // todo: revise somehow in the future
            that._roomListRefresh();
            Success();
        };

        this.hitagi.room.join_room(Name, Password, customSuccess, Error);
    }

    leaveRoom(Name, Success, Error) {
        var that = this;

        var customSuccess = function() {
            that.trigger('room_leaved', Name);
            // todo: revise somehow in the future
            that._roomListRefresh();
            Success();
        };

        this.hitagi.room.leave_room(Name, customSuccess, Error);
    }

    createVirtualRoom(Name, Password, Success, Error) {
        this.hitagi.room.create_room(Name, Password, Success, Error);
    }

    destroyVirtualRoom(RoomId, Success, Error) {
        this.hitagi.chat.destroy_room(RoomId, Success, Error);
    }

    can(Permission) {
        if (this.hitagi.capabilities) {
            return this.hitagi.capabilities[Permission];
        } else {
            return false;
        }
    }

    onBaseLibNotLoaded(handler) { this.on('base_lib_not_loaded', handler) }
}


// WEBPACK FOOTER //
// ./src/interfaces/chat/hitagi.js